import React from "react";

export default function Chip({ children, className = "" }) {
  return (
    <span
      className={[
        "inline-flex items-center rounded-full",
        "border border-white/10 bg-white/[0.04]",
        "px-4 py-2 text-xs font-semibold tracking-wide",
        "text-white/75",
        className,
      ].join(" ")}
    >
      {children}
    </span>
  );
}
